module.exports = __webpack_public_path__ + "img/videowiki.a049e67e.svg";